import {AuthTokens, AuthUser} from '~/auth/AuthContext';
import rollbar from '~/vendor/rollbar';

type AccessTokenMode = {
  withAccessToken: true;
  withIdToken?: false;
};

type IdTokenMode = {
  withAccessToken?: false;
  withIdToken: true;
};

type AnonymousMode = {
  withAccessToken?: false;
  withIdToken?: false;
};

export type AuthMode = AccessTokenMode | IdTokenMode | AnonymousMode;

interface GetAuthorizationHeaderProps {
  url: string;
  getTokens: () => Promise<AuthTokens>;
  identityProvider: string;
  user?: AuthUser;
  authMode?: AuthMode;
  queryParams?: URLSearchParams | Record<string, unknown>;
  isPublic?: boolean;
}

export const GetAuthorizationHeader = async (
  props: GetAuthorizationHeaderProps
) => {
  const {
    url,
    getTokens,
    identityProvider,
    user,
    authMode,
    queryParams: params,
    isPublic
  } = props;
  const isAuthenticated = Boolean(user);
  const withAccessToken = authMode?.withAccessToken ?? false;
  const withIdToken = authMode?.withIdToken ?? false;
  const getOptionalTokens = () =>
    isAuthenticated
      ? getTokens()
      : {idToken: undefined, accessToken: undefined};
  const reportToRollbar = (tokenType: string) =>
    rollbar.error(`Missing ${tokenType} in request to ${url}`, {
      params,
      identityProvider
    });
  const {accessToken, idToken} = await getOptionalTokens();
  if (withAccessToken) {
    if (accessToken) {
      return `Bearer ${accessToken}`;
    }
    if (isPublic) {
      return undefined;
    }
    reportToRollbar('access token');
  } else if (withIdToken) {
    if (idToken) {
      return `Bearer ${idToken}`;
    }
    if (isPublic) {
      return undefined;
    }
    reportToRollbar('id token');
  }
  return undefined;
};
